import * as React from 'react';
import { cn } from '@common/bw-ui/lib/utils';

export interface PasswordCriterion {
  label: string;
  met: boolean;
}

export interface PasswordCriteriaProps {
  criteria: PasswordCriterion[];
  title?: string;
  className?: string;
}

function PasswordCriteria({
  criteria,
  title = 'Password requirements:',
  className,
}: PasswordCriteriaProps) {
  return (
    <div
      data-slot="password-criteria"
      className={cn(
        'tw:text-sm tw:font-normal tw:leading-7 tw:text-foreground',
        className,
      )}
    >
      <p className="tw:m-0">{title}</p>
      <ul className="tw:m-0 tw:list-none tw:p-0">
        {criteria.map((criterion) => (
          <li
            key={criterion.label}
            {...(criterion.met && { 'data-met': '' })}
            className="tw:flex tw:items-baseline tw:gap-1"
          >
            <span
              aria-hidden="true"
              className={cn(
                'tw:w-3 tw:text-center',
                criterion.met && 'tw:text-success',
              )}
            >
              {criterion.met ? '✓' : '•'}
            </span>
            {criterion.label}
            <span className="tw:sr-only">
              {criterion.met ? ' (met)' : ' (not met)'}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export { PasswordCriteria };
